export default function DummyCheckoutFields() {
  return (
    <div className="checkout-fields">
      <label>
        Shipping Name
        <input className="input" placeholder="Demo Customer" />
      </label>
      <label>
        Shipping Address
        <textarea className="input" rows={3} placeholder="House no, street, city, state, PIN" />
      </label>
      <label>
        Payment Method
        <select className="select" defaultValue="cod">
          <option value="cod">Cash on Delivery</option>
          <option value="card">Dummy Card</option>
          <option value="upi">Dummy UPI</option>
        </select>
      </label>
      <label>
        Discount Coupon
        <input className="input" placeholder="NYAFAZ10" />
      </label>
    </div>
  );
}
